"use client";

import { Center, Flex, HStack, Link, Text } from "@chakra-ui/react";
import EmptyState from "../EmptyState/EmptyState";
import { Button } from "@/_components/lib/ui/button";
import { useTranslations } from "next-intl";

interface ErrorProps {
  onTryAgain?: () => void;
}

export const ErrorComponent = ({ onTryAgain }: ErrorProps) => {
  const t = useTranslations("error.general");

  return (
    <Center h="100vh" flexDir="column">
      <Flex flexDir="column" align="center" justify="center">
        <EmptyState
          isGrayscale={false}
          title={t("title")}
          description=""
          placeholderImage="we-got-a-problem"
          isDescription={false}
        >
          <Text
            fontSize="sm"
            fontWeight="semibold"
            fontFamily="body"
            color="neutral.700"
            textAlign="center"
          >
            {t("description")}{" "}
            <Link
              href="mailto:service@knoot.ai"
              color="primary.500"
              fontWeight="bold"
              _hover={{ textDecoration: "underline" }}
            >
              service@knoot.ai
            </Link>
          </Text>
        </EmptyState>
        <HStack gap={4}>
          {onTryAgain && <Button onClick={onTryAgain}>{t("try_again")}</Button>}
          <Button asChild visual="outline">
            <Link textDecor="none" href="mailto:service@knoot.ai">
              {t("contact_support")}
            </Link>
          </Button>
        </HStack>
      </Flex>
    </Center>
  );
};
